import React, { useEffect, useRef, useState } from "react";
import "../Styles/CLoudProLoginPage.css";
 import logo from '../Assets/icons/newLogo.png'
import { IoEyeOff } from "react-icons/io5";
import { IoEye  } from "react-icons/io5";
import { Link } from 'react-router-dom';
import Axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
export default function CloudProLogin() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: false, password: false });
  const [loginError, setLoginError] = useState(""); 

// below code for MDID
  const navigate = useNavigate();
  const location = useLocation();
const { mdId } = useParams();

  const setOnce = (key, value) => {
    try {
      if (localStorage.getItem(`${key}_locked`) === "1") return; 
      localStorage.setItem(key, value);
      localStorage.setItem(`${key}_locked`, "1");
    } catch (_) { /* ignore storage errors */ }
  };

  // If someone hits this page without mdId in the path, bounce home
  useEffect(() => {
    if (!mdId) navigate("/", { replace: true });
  }, [mdId, navigate]);

  
  useEffect(() => {
    if (mdId) localStorage.setItem("md_ref", mdId);
  }, [mdId]);

 
  const [openYubikeyDialog, setOpenYubikeyDialog] = useState(false);
  const [yubikeyCode, setYubikeyCode] = useState("");
  const yubikeyInputRef = useRef(null);
  const dialogContentRef = useRef(null);

 
  // useEffect(() => {
  //   if (localStorage.getItem("@customer") === "true") {
  //     const rawNext = new URLSearchParams(location.search).get("next");
  //     const decodedNext = rawNext ? decodeURIComponent(rawNext) : null;
  //     navigate(decodedNext || `/${mdId}/cloudproheader`, { replace: true });
  //   }
  // }, [location.search, navigate, mdId]);

    const handleLogin = () => {

 
        const newErrors = {
          email: email.trim() === "",
          password: password.trim() === ""
        };

        setErrors(newErrors);

        
        if (newErrors.email || newErrors.password) {
          setLoginError("Please fill all required fields");
          return;
        }


  setLoginError("");

  Axios.post(`/customer_login`, {
    email: email,
    password: password,
    mdId: mdId,                      // Optional: include MD if/when the backend wants it
                                    // md_id: mdId,

  })
    .then((res) => {
      // if (res.data?.success) {

      //   localStorage.setItem("userEmail", email);

      //   if (email === "gayatri@velox.ca") {
      //     localStorage.setItem("@customer", "true");
      //     localStorage.setItem("mdId", mdId);
      //     localStorage.setItem("role", 2);

      //     const rawNext = new URLSearchParams(location.search).get("next");
      //     const decodedNext = rawNext ? decodeURIComponent(rawNext) : null;

      //     navigate(decodedNext || `/${mdId}/cloudproheader`);
      //   } 
      //   else {
      //     setOpenYubikeyDialog(true);
      //   }

       if (res.data?.success) {
          toast.success("Verified your credential, please verify your YubiKey!");
          localStorage.setItem("userEmail", email);
          setOpenYubikeyDialog(true);
        
      } else {
        setLoginError(res.data?.msg || "Incorrect email or password");
      }
    })
    .catch(() => {
      setLoginError("Your Email and password didn't match!");
    });
};
const handleYubikeyVerification = () => {
    const email = localStorage.getItem("userEmail");
    Axios.post(`/customer_login_verify_yubikey`, {
      email,
      yubikeyContent: yubikeyCode,
    })
      .then((res) => {
        if (res.data?.success) {
          localStorage.setItem("@customer", "true");
          localStorage.setItem("mdId", mdId);
          localStorage.setItem("role", res.data.role); // default to customer role
          if (res.data.siId) {
            setOnce("siId", String(res.data.siId));
          }
          const rawNext = new URLSearchParams(location.search).get("next");
          const decodedNext = rawNext ? decodeURIComponent(rawNext) : null;
          window.location.replace(decodedNext || `/${mdId}/cloudproheader`);
        } else {
          setLoginError(res.data?.msg || "VELOX Cloud Key verification failed");
          yubikeyInputRef.current?.focus();
        }
        setYubikeyCode("");
      })
      .catch(() => {
        setYubikeyCode("");
        yubikeyInputRef.current?.focus();
      });
  };

  // keep focus on input while dialog is open (for fast YubiKey OTP paste)
  useEffect(() => {
    const handleDialogClick = (e) => {
      if (
        dialogContentRef.current &&
        yubikeyInputRef.current &&
        !yubikeyInputRef.current.contains(e.target)
      ) {
        yubikeyInputRef.current.focus();
      }
    };
    if (openYubikeyDialog) {
      yubikeyInputRef.current?.focus();
      document.addEventListener("click", handleDialogClick);
    }
    return () => document.removeEventListener("click", handleDialogClick);
  }, [openYubikeyDialog]);
  return (
    <>
    <div className="main-container">
      <div className="login-card">
        <div className="language-select">
          <select>
            <option>English</option>
            <option></option>
            <option></option>
          </select>
        </div>
        <div className="logo-box">
          <img src={logo} alt="logo" style={{   maxWidth: "250px",
  width: "100%",
  height: "auto",
  objectFit: "contain"}}/>
        </div>

        <h2 className="title">Welcome Back</h2>
        <p className="subtitle">Please enter your details to login</p>

        <div className="input-group">
          <label>Email</label>
          <input type="email" placeholder="Enter your email"  value={email}
           onChange={(e) => {
    setEmail(e.target.value);
    setErrors({ ...errors, email: false }); 
  }}
            className={errors.email ? "input-error" : ""}/>
        </div>

        <div className="input-group">
          <label>Password</label>
          <div className="password-box">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"  value={password}
              onChange={(e) => {
    setPassword(e.target.value);
    setErrors({ ...errors, password: false }); 
  }}
              className={errors.password ? "input-error" : ""}
            />
            <span
              className="eye"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <IoEyeOff /> : <IoEye />}
            </span>
          </div>
          <div className="forgot"><Link to="/forgot-password" className="red-link">Forgot Password</Link></div>
        </div>
         <p className="login-error">
  {loginError || ""}
</p>
        <button className="signin-btn" onClick={handleLogin}>Login</button>

        {/* <p className="bottom-text">
          Don't have an account? <span><Link to="/cloudproregister" className="red-link">Sign up</Link></span>
        </p> */}
      </div>
       <p className="copyright">
   © {new Date().getFullYear()} Velox Life Safety Inc. All rights reserved.
  </p>
    </div>
    
    <Dialog open={openYubikeyDialog} onClose={() => setOpenYubikeyDialog(false)}>
        <DialogTitle>YubiKey Verification</DialogTitle>
        <DialogContent ref={dialogContentRef}>
          <p>Please insert your YubiKey, touch it, and then verify.</p>
          <input
            ref={yubikeyInputRef}
            type="text"
            className="yubikeycode-field-hidden"
            placeholder="Enter YubiKey Code"
            value={yubikeyCode}
            onChange={(e) => setYubikeyCode(e.target.value)}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenYubikeyDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleYubikeyVerification}
            color="primary" disabled={!(yubikeyCode && yubikeyCode.length >= 12)}
          >
            Verify
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
   </> 
  );
}